import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Typography, Box } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import AppHeader from '../components/common/AppHeader'
import Avatar3DTool from '../components/photoTools/Avatar3DTool'

const PhotoAvatar3DPage: React.FC = () => {
  const navigate = useNavigate()
  const { user, logout, isAdmin } = useAuth()

  const handleBackClick = () => {
    navigate('/photo-tools')
  }

  return (
    <>
      <AppHeader
        title="3D Avatar"
        username={user?.username}
        showAdminButton={isAdmin}
        showBackButton
        onBackClick={handleBackClick}
        onLogout={logout}
      />

      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            3D avatar
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Konwersja zdjęcia do modelu 3D (GLB) + podgląd w przeglądarce
          </Typography>
        </Box>

        <Avatar3DTool />
      </Container>
    </>
  )
}

export default PhotoAvatar3DPage

